import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import ProductRow from './product_row';
import {map, chunk} from 'lodash';

export default function ProductGrid({ products, sold_content_type, hide_product_info_button }) {
  const productRows = chunk(products, 3);
  return (
    <div className="product-grid">
      <div className="product-grid-header">
        <RosettaFormattedMessage parentFilename={__filename}
          id="header"
          description="Text that appears above the product grid on entry pages"
          defaultMessage="Shop This Story"
        />
      </div>
      <div className="products">
        {
          map(productRows, (row) => {
            const [{ id }] = row;
            return (
              <ProductRow
                key={id}
                products={row}
                sold_content_type={sold_content_type}
                hide_product_info_button={hide_product_info_button}
              />
            );
          })
        }
      </div>
    </div>
  );
}

ProductGrid.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  sold_content_type: PropTypes.string,
  hide_product_info_button: PropTypes.bool
};

ProductGrid.defaultProps = {
  products: []
};
